module.exports = __webpack_public_path__ + "ins10.png?dbef5e496e44e7761d2a78b145ac6d4e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ins10.png
// module id = 161
// module chunks = 0